// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"1d7a8564","364":"7e48b250","750":"eb2e7e11"}[chunkId] + ".chunk.js";
};